import { IntlShape } from "react-intl";

import { ScenarioLayer } from "@nens/rana/api-v1";
import { objectFromEntries, removeNullUndefined } from "@nens/shared-utils";

type DisabledLayersScenarioProps = {
  intl: IntlShape;
  layers: ScenarioLayer[];
};

export const getDisabledLayersScenario = ({ intl, layers }: DisabledLayersScenarioProps) => {
  return objectFromEntries(
    removeNullUndefined(
      layers.map((layer) => {
        if (!layer.code.endsWith("depth-dtri") && !layer.name.endsWith("(timeseries)")) return null;
        return [
          layer.name,
          intl.formatMessage({
            id: "publication_map.timeseries.disabled",
            defaultMessage:
              "We apologize for the inconvenience, but displaying a time series is not yet supported in Rana and will not be shown at this time.",
          }),
        ];
      })
    )
  );
};
